import api from '@src/util/api';
import apolloClient from '@src/graphql/apollo';
import { LOCKED_STATES } from '@src/constants';
import { CustomerDocument, CustomerQuery } from '@src/graphql/generated';
import { NoticeActions } from './notice.enum';
import { SetLoadingAction, SetNoticeAction } from './notice.interface';

const INACTIVE_STATES_DICTIONARY = {
  SUBSCRIPTION_INACTIVE: 'subscription_inactive',
  TRIAL_ACTIVE: 'trial_active',
  TRIAL_ENDED: 'trial_ended',
};

export const setLoading = (isLoading: boolean): SetLoadingAction => {
  return {
    payload: { isLoading: isLoading },
    type: NoticeActions.SET_NOTICE_LOADING,
  };
};

export const setNotice = ({ notice }): SetNoticeAction => {
  return {
    payload: { isLoading: false, notice: notice },
    type: NoticeActions.NOTICE_SET,
  };
};

export const fetchNotice = () => {
  return async dispatch => {
    dispatch(setLoading(true));

    const { data } = await apolloClient.query<CustomerQuery>({
      fetchPolicy: 'network-only',
      query: CustomerDocument,
    });

    const state = data.customer.planInfo?.state;

    if (LOCKED_STATES.includes(state)) {
      dispatch(setNotice({ notice: INACTIVE_STATES_DICTIONARY[state] }));

      return;
    }

    // check other notices
    const { notice } = await api('/api/notice');

    if (notice) {
      dispatch(setNotice({ notice: notice }));

      return;
    }

    dispatch(setNotice({ notice: '' }));
  };
};
